import { Formik, FormikActions, FormikProps } from 'formik';
import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { SelectAsync } from '../../../../../components/input/select/main';
import Paginate from '../../../../../components/table/paginate';
import Translator from '../../../../../core/i18n';
import { IAction, IAppState } from '../../../../../models/action/core';
import * as Actions from '../../../../../store/actions/examSession';
import { Notification } from '../../../../../components/notification/main';
import { IPagedQueryS } from '../../../../../models/components/paginate';
import { IFilter, IFilterExamQuestions, IFilterFormik, IQuestions } from '../../../../../models/components/add-exam-sessions';
import { QuestionType } from '../../../../../models/enums/QuestionType';
import imgAnn from '../../../../../static/images/announcement.svg';
import { boolean } from 'yup';
import Tooltip from '../../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('Add Session Add Question');

interface IAddQuestionModalProps {
    currentTab: string;
    coursePageActivityId?: string;
    coursePageClassId?: string;
    examId?: string;
    examSessionId: string;
    dispatch?: any;
    addQuestionDatas?: {
        filters: IPagedQueryS;
        results: IQuestions[] | null;
    };
    isDefaultUpdateQuestion?: number;
    publishDatas?: any;
}

interface IAddQuestionModalState {
    filters: IPagedQueryS;
    isAll: boolean;
    disAllowedQuestionIds: string[];
    selectedQuestionIds: string[];
    filterInitialValues: any; //IFilter
    questionsLoaded: boolean;
}

export class AddQuestionModal extends Component<IAddQuestionModalProps, IAddQuestionModalState> {
    constructor(props: any) {
        super(props);

        this.state = {
            filters: {
                page: 1,
                take: 20,
                total: 0
            },
            isAll: false,
            disAllowedQuestionIds: [],
            selectedQuestionIds: [],
            filterInitialValues: {
                keywordIds: [],
                categoryIds: [],
                topicIds: [],
                masterCourseIds: [],
                courseIds: [],
                termIds: []
            },
            questionsLoaded: false
        };

        this.onSubmit.bind(this);
    }

    componentDidUpdate(prevProps: any) {
        if (
            prevProps.isDefaultUpdateQuestion &&
            this.props.isDefaultUpdateQuestion &&
            prevProps.isDefaultUpdateQuestion !== this.props.isDefaultUpdateQuestion
        ) {
            this.setState({
                isAll: false,
                selectedQuestionIds: [],
                disAllowedQuestionIds: [],
                filterInitialValues: {
                    keywordIds: [],
                    categoryIds: [],
                    topicIds: [],
                    masterCourseIds: [],
                    courseIds: [],
                    termIds: []
                },
                filters: {
                    page: 1,
                    take: 20,
                    total: 0
                }
            });
        }
    }

    onSubmit = async (model: IFilterFormik, FormActions: FormikActions<IFilterFormik>) => {
        let newFilterModel: IFilter = {
            keywordIds: '',
            categoryIds: '',
            topicIds: '',
            masterCourseIds: '',
            courseIds: '',
            termIds: '',
            questionText: ''
        };
        if(model)
        {
            newFilterModel.questionText = model.questionText;

            if(model.keywordIds && model.keywordIds.length > 0)
            {
                newFilterModel.keywordIds = model.keywordIds.toString();
            }
            if(model.categoryIds && model.categoryIds.length > 0)
            {
                newFilterModel.categoryIds = model.categoryIds.toString();
            }
            if(model.topicIds && model.topicIds.length > 0)
            {
                newFilterModel.topicIds = model.topicIds.toString();
            }
            if(model.masterCourseIds && model.masterCourseIds.length > 0)
            {
                newFilterModel.masterCourseIds = model.masterCourseIds.toString();
            }
            if(model.courseIds && model.courseIds.length > 0)
            {
                newFilterModel.courseIds = model.courseIds.toString();
            }
            if(model.termIds && model.termIds.length > 0)
            {
                newFilterModel.termIds = model.termIds.toString();
            }
            
        }
        await this.getQuestion(newFilterModel, this.state.filters);
        this.setState({ filterInitialValues: model });
        FormActions.setSubmitting(false);
    };

    getQuestion = async (filters: IFilter, paging: IPagedQueryS) => {
        filters.examSessionId = this.props.examSessionId;
        this.setState({questionsLoaded: true})
        this.props.dispatch(Actions.ExamSessionAddQuestionList(filters, paging, '', 'get', this.getquestionCallback));
        const searched = document.getElementById('searched');
        const unsearched = document.getElementById('unsearched');
        if (unsearched && searched) {
            unsearched.className = 'd-none';
            searched.className = 'd-block';
        }
    };

    getquestionCallback = () =>
    {
        this.setState({questionsLoaded: false})
    }

    validateAndSubmit = async (formik: FormikProps<IFilterFormik>) => {
        let isCompleted: boolean = true;

        const validations = await formik.validateForm().then((result: any) => result);
        Object.keys(validations).forEach((validationKey: string) => {
            Notification.setNotification(
                'error',
                T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                'topRight'
            );

            isCompleted = false;
        });

        if (isCompleted) {
            formik.submitForm();
        }
    };

    getValidation = () => {
        // if (
        //     this.props.coursePageclassInformation &&
        //     this.props.coursePageclassInformation.isWeekly === true &&
        //     this.props.coursePageclassInformation.startDate &&
        //     this.props.coursePageclassInformation.endDate
        // ) {
        //     return getValidation({
        //         isProjectSubActivity: this.props.isProjectSubActivity,
        //         startDate: this.props.coursePageclassInformation.startDate,
        //         endDate: this.props.coursePageclassInformation.endDate,
        //         dateFormat: _common.findDateFormat(this.props.userPreferences!),
        //         termWeeks: this.props.courseContentTermWeeks,
        //         isUpdate: this.props.updateActivityId ? true : false
        //     });
        // } else {
        //     return getValidation({ isProjectSubActivity: this.props.isProjectSubActivity });
        // }
    };

    sort = async (sortkey: string, orderBy: string) => {
        const sortString = sortkey + '_' + orderBy;
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                orderBy: sortString
            }
        });
        await this.getQuestion(this.state.filterInitialValues, this.state.filters);
    };

    onPageChange = async (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        let newFilterModel: IFilter = {
            keywordIds: '',
            categoryIds: '',
            topicIds: '',
            masterCourseIds: '',
            courseIds: '',
            termIds: '',
            questionText: ''
        };
        if(this.state.filterInitialValues)
        {
            newFilterModel.questionText = this.state.filterInitialValues.questionText;

            if(this.state.filterInitialValues.keywordIds && this.state.filterInitialValues.keywordIds.length > 0)
            {
                newFilterModel.keywordIds = this.state.filterInitialValues.keywordIds.toString();
            }
            if(this.state.filterInitialValues.categoryIds && this.state.filterInitialValues.categoryIds.length > 0)
            {
                newFilterModel.categoryIds = this.state.filterInitialValues.categoryIds.toString();
            }
            if(this.state.filterInitialValues.topicIds && this.state.filterInitialValues.topicIds.length > 0)
            {
                newFilterModel.topicIds = this.state.filterInitialValues.topicIds.toString();
            }
            if(this.state.filterInitialValues.masterCourseIds && this.state.filterInitialValues.masterCourseIds.length > 0)
            {
                newFilterModel.masterCourseIds = this.state.filterInitialValues.masterCourseIds.toString();
            }
            if(this.state.filterInitialValues.courseIds && this.state.filterInitialValues.courseIds.length > 0)
            {
                newFilterModel.courseIds = this.state.filterInitialValues.courseIds.toString();
            }
            if(this.state.filterInitialValues.termIds && this.state.filterInitialValues.termIds.length > 0)
            {
                newFilterModel.termIds = this.state.filterInitialValues.termIds.toString();
            }
            
        }
        await this.getQuestion(newFilterModel, this.state.filters);
    };

    onSelectQuestion = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            if (!this.state.isAll) {
                const selectedIds = Object.assign([], this.state.selectedQuestionIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (event.target.checked && id) {
                    selectedIds.push(id);
                } else if (!event.target.checked && id) {
                    const index = selectedIds.indexOf(id);
                    if (index !== -1) {
                        selectedIds.splice(index, 1);
                    }
                }
                this.setState({ selectedQuestionIds: selectedIds });
            } else {
                const disAllowedIds = Object.assign([], this.state.disAllowedQuestionIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (!event.target.checked && id) {
                    disAllowedIds.push(id);
                } else if (event.target.checked && id) {
                    const index = disAllowedIds.indexOf(id);
                    if (index !== -1) {
                        disAllowedIds.splice(index, 1);
                    }
                }
                this.setState({ disAllowedQuestionIds: disAllowedIds });
            }
        }
    };

    addSelectedQuestions = () => {
        let newFilterModel: IFilter = {
            keywordIds: '',
            categoryIds: '',
            topicIds: '',
            masterCourseIds: '',
            courseIds: '',
            termIds: '',
            questionText: ''
        };
        if(this.state.filterInitialValues)
        {
            newFilterModel.questionText = this.state.filterInitialValues.questionText;

            if(this.state.filterInitialValues.keywordIds && this.state.filterInitialValues.keywordIds.length > 0)
            {
                newFilterModel.keywordIds = this.state.filterInitialValues.keywordIds.toString();
            }
            if(this.state.filterInitialValues.categoryIds && this.state.filterInitialValues.categoryIds.length > 0)
            {
                newFilterModel.categoryIds = this.state.filterInitialValues.categoryIds.toString();
            }
            if(this.state.filterInitialValues.topicIds && this.state.filterInitialValues.topicIds.length > 0)
            {
                newFilterModel.topicIds = this.state.filterInitialValues.topicIds.toString();
            }
            if(this.state.filterInitialValues.masterCourseIds && this.state.filterInitialValues.masterCourseIds.length > 0)
            {
                newFilterModel.masterCourseIds = this.state.filterInitialValues.masterCourseIds.toString();
            }
            if(this.state.filterInitialValues.courseIds && this.state.filterInitialValues.courseIds.length > 0)
            {
                newFilterModel.courseIds = this.state.filterInitialValues.courseIds.toString();
            }
            if(this.state.filterInitialValues.termIds && this.state.filterInitialValues.termIds.length > 0)
            {
                newFilterModel.termIds = this.state.filterInitialValues.termIds.toString();
            }
            
        }
        if (
            this.props.publishDatas!.activeStatus === 0 &&
            this.props.publishDatas!.isPassive === 1
        ) {
            if (
                this.props.examSessionId &&
                this.props.examId &&
                ((this.state.selectedQuestionIds && this.state.selectedQuestionIds.length) || this.state.isAll)
            ) {
                this.props.dispatch(
                    Actions.ExamSessionAddQuestion(
                        newFilterModel,
                        this.state.isAll,
                        this.props.examSessionId,
                        this.props.examId,
                        this.state.selectedQuestionIds,
                        this.addSelectedQuestionsCallBack,
                        this.state.disAllowedQuestionIds,
                        '',
                        'get'
                    )
                );
            }
        } else {
            Notification.setNotification('error', T.t('r_activity_exam_session_edit_error').replace('{0}', T.t('r_activity_exam_session_edit_error_questions')), 'topRight');
        }
    };

    addSelectedQuestionsCallBack = async () => {
        let newFilterModel: IFilter = {
            keywordIds: '',
            categoryIds: '',
            topicIds: '',
            masterCourseIds: '',
            courseIds: '',
            termIds: '',
            questionText: ''
        };
        if(this.state.filterInitialValues)
        {
            newFilterModel.questionText = this.state.filterInitialValues.questionText;

            if(this.state.filterInitialValues.keywordIds && this.state.filterInitialValues.keywordIds.length > 0)
            {
                newFilterModel.keywordIds = this.state.filterInitialValues.keywordIds.toString();
            }
            if(this.state.filterInitialValues.categoryIds && this.state.filterInitialValues.categoryIds.length > 0)
            {
                newFilterModel.categoryIds = this.state.filterInitialValues.categoryIds.toString();
            }
            if(this.state.filterInitialValues.topicIds && this.state.filterInitialValues.topicIds.length > 0)
            {
                newFilterModel.topicIds = this.state.filterInitialValues.topicIds.toString();
            }
            if(this.state.filterInitialValues.masterCourseIds && this.state.filterInitialValues.masterCourseIds.length > 0)
            {
                newFilterModel.masterCourseIds = this.state.filterInitialValues.masterCourseIds.toString();
            }
            if(this.state.filterInitialValues.courseIds && this.state.filterInitialValues.courseIds.length > 0)
            {
                newFilterModel.courseIds = this.state.filterInitialValues.courseIds.toString();
            }
            if(this.state.filterInitialValues.termIds && this.state.filterInitialValues.termIds.length > 0)
            {
                newFilterModel.termIds = this.state.filterInitialValues.termIds.toString();
            }
            
        }
        await this.getQuestion(newFilterModel, this.state.filters).then(() => {
            this.setState({
                selectedQuestionIds: [],
                disAllowedQuestionIds: [],
                isAll: false
            });
            if (this.props.examSessionId && this.props.examId) {
                const filters: IFilterExamQuestions = { examSessionId: this.props.examSessionId, examId: this.props.examId };
                this.props.dispatch(Actions.ExamSessionQuestionList(filters, { page: 1, take: 20, total: 0 }, '', 'get'));
                if (this.props.coursePageActivityId && this.props.coursePageClassId) {
                    this.props.dispatch(
                        Actions.ExamSessionListGetAction(
                            this.props.examId,
                            this.props.coursePageActivityId,
                            this.props.coursePageClassId,
                            '',
                            'get',
                            this.props.examSessionId
                        )
                    );
                    this.props.dispatch(Actions.ExamSessionPublishDatas(this.props.examId, this.props.examSessionId, '', 'get'));
                }
            }
        });
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            this.setState({ isAll: event.target.checked });
            if (!event.target.checked) {
                this.setState({ disAllowedQuestionIds: [] });
            }
        }
    };

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionAddQuestion' ? ' show active' : '')}
                style={{ width: '100%' }}
                role="tabpanel"
                aria-labelledby="all-users-tab"
            >
                <div className="container mt-3">
                    {/*<div className="title ">
                        <span className="d-flex align-items-center">{T.t('r_gen_exam_session_page_add_questions')}</span>
                    </div>*/}
                    <Formik initialValues={this.state.filterInitialValues} onSubmit={this.onSubmit} validationSchema={this.getValidation}>
                        {formik => {
                            return (
                                <>
                                    <div className="filter-fields mt-4">
                                        <form onSubmit={formik.handleSubmit} key={'project_add_user_modal'}>
                                            <div className="row mt-1">
                                                <div className="col">
                                                    <div className="form-input form-group date-picker mb-3">
                                                        <SelectAsync
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{ SearchedText: '', SelectedIds: formik.values.keywordIds, Take: 5 }}
                                                            placeHolder={T.t('r_gen_question_keyword_select')}
                                                            url={'api/examsession/keyword/get'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'keywordIds'}
                                                            value={formik.values.keywordIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.keywordIds}
                                                            touched={formik.touched.keywordIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="form-input form-group date-picker mb-3">
                                                        <SelectAsync
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                SearchedText: '',
                                                                SelectedIds: formik.values.categoryIds,
                                                                Take: 5
                                                            }}
                                                            placeHolder={T.t('r_gen_question_category_select')}
                                                            url={'api/examsession/categories/get'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'categoryIds'}
                                                            value={formik.values.categoryIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.categoryIds}
                                                            touched={formik.touched.categoryIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="form-input form-group date-picker mb-3">
                                                        <SelectAsync
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                SearchedText: '',
                                                                CourseId: this.props.coursePageActivityId,
                                                                SelectedIds: formik.values.topicIds
                                                            }}
                                                            placeHolder={T.t('r_add_exam_question_weighting_topic_select')}
                                                            url={'api/exam/topic/get'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'topicIds'}
                                                            value={formik.values.topicIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.topicIds}
                                                            touched={formik.touched.topicIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col">
                                                    <div className="form-input form-group date-picker  mb-3">
                                                        <SelectAsync
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{
                                                                SearchedText: '',
                                                                SelectedIds: formik.values.masterCourseIds,
                                                                Take: 5
                                                            }}
                                                            placeHolder={T.t('r_gen_master_course_select')}
                                                            url={'api/examsession/mastercourses/get'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'masterCourseIds'}
                                                            value={formik.values.masterCourseIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.masterCourseIds}
                                                            touched={formik.touched.masterCourseIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="form-input form-group date-picker  mb-3">
                                                        <SelectAsync
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{ SearchedText: '', GetTypes: 'Course', Skip: 0, Take: 10 }}
                                                            placeHolder={T.t('r_gen_course_select')}
                                                            url={'api/organization/search'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'courseIds'}
                                                            value={formik.values.courseIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.courseIds}
                                                            touched={formik.touched.courseIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="form-input form-group date-picker mb-3">
                                                        <SelectAsync
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            requestType={'post'}
                                                            parameter={{ SearchedText: '', SelectedIds: formik.values.termIds, Take: 5 }}
                                                            placeHolder={T.t('r_gen_term_select')}
                                                            url={'api/examsession/terms/get'}
                                                            closeMenuOnScroll={false}
                                                            closeMenuOnSelect={false}
                                                            name={'termIds'}
                                                            value={formik.values.termIds}
                                                            onChange={formik.handleChange}
                                                            setFieldValue={formik.setFieldValue}
                                                            errors={formik.errors.termIds}
                                                            touched={formik.touched.termIds}
                                                            isTouched={formik.setFieldTouched}
                                                            hasLocalization={true}
                                                            setFieldOnlyValue={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="text-right mt-3">
                                        <button
                                            data-toggle="modal"
                                            data-target="#report-modal"
                                            className="ml-2 category-tag-square tag-green"
                                            // tslint:disable-next-line:jsx-no-lambda
                                            onClick={() => this.validateAndSubmit(formik)}
                                            disabled={formik.isSubmitting}
                                            style={{ minWidth: '120px', padding: '6px 3%' }}
                                        >
                                            {T.t('r_gen_search')} <i className="material-icons ml-2">search</i>
                                        </button>
                                    </div>
                                </>
                            );
                        }}
                    </Formik>

                    {this.props.addQuestionDatas && this.props.addQuestionDatas.results && this.props.addQuestionDatas.results.length > 0 && (
                        <div className="no-hover question-row align-items-baseline">
                            <div className="tick-radio position-relative">
                                <input
                                    onChange={this.selectAll}
                                    type="checkbox"
                                    checked={this.state.isAll}
                                    name="demo"
                                    defaultValue="one"
                                    id="radio-three"
                                    className="form-radio mr-2"
                                />
                                <span style={{ color: '#abaaa7' }}>{T.t('r_select_all')}</span>
                            </div>
                            {this.props.addQuestionDatas &&
                                this.props.addQuestionDatas.results &&
                                this.props.addQuestionDatas.results.length > 0 &&
                                ((this.state.selectedQuestionIds && this.state.selectedQuestionIds.length) || this.state.isAll) ? (
                                <div className="row justify-content-end mt-3 " style={{ padding: 'inherit' }}>
                                    <button className="ml-3 category-tag-square tag-green" onClick={this.addSelectedQuestions}>
                                        <i className="material-icons mr-1 icon-rtl">done</i>
                                        {T.t('r_gen_exam_session_add_question')}&nbsp; (
                                        {!this.state.isAll
                                            ? this.state.selectedQuestionIds.length
                                            : this.props.addQuestionDatas.filters.total}
                                        )
                                    </button>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    )}

                    {this.state.questionsLoaded ?
                     (<div className="row mt-4 spinner_bg" style={{height: "250px"}}>
                        <div className="donut" />
                        <span className="report_title">{T.t('r_questions_loading')}</span>
                    </div>)
                     :
                     this.props.addQuestionDatas && this.props.addQuestionDatas.results && this.props.addQuestionDatas.results.length ? (
                         this.props.addQuestionDatas.results.map((item: IQuestions) => {
                             return (
                                 <div className="question-list mt-3">
                                     <div key={'question-' + item.questionId} className="question-row">
                                         <div className="tick-radio position-relative">
                                             {item.alreadyUsed ? (
                                                 <>
                                                     <Tooltip data={T.t('r_gen_exam_session_question_already_user')} position='top'>
                                                         <i className="material-icons mr-2" style={{ width: 20, height: 20, fontSize: 20 }}>
                                                             info
                                                         </i>
                                                     </Tooltip>
 
                                                     <input className="form-radio" style={{ display: 'none' }} />
                                                 </>
                                             ) : (
                                                 <input
                                                     data-id={item.questionId}
                                                     onChange={this.onSelectQuestion}
                                                     type="checkbox"
                                                     name="demo"
                                                     defaultValue="one"
                                                     id="radio-three"
                                                     checked={
                                                         (!this.state.isAll && this.state.selectedQuestionIds.includes(item.questionId)) ||
                                                         (this.state.isAll && !this.state.disAllowedQuestionIds.includes(item.questionId))
                                                     }
                                                     className="form-radio mr-2"
                                                 />
                                             )}
 
                                             <label
                                                 className="text-truncate text-dark"
                                                 dangerouslySetInnerHTML={{ __html: item.questionText.replace(/<\/?[^>]+(>|$)/g, '') }}
                                             />
                                         </div>
                                         <div className="row-options">
                                             <div className="d-flex align-items-end justify-content-end" style={{ minWidth: 204 }}>
                                                 <div className="tags mr-1" style={{ minWidth: 66 }}>
                                                     {item.difficulty && (
                                                         <button className="tag-gray small-tag text-uppercase">
                                                             {T.t('r_exam_difficulty_' + item.difficulty.replace(' ', ''))}
                                                         </button>
                                                     )}
                                                 </div>
                                                 {item.questionCategories && item.questionCategories !== ' ' && (
                                                     <button
                                                         style={{ maxWidth: 65, marginRight: 2 }}
                                                         className="tag-web small-tag text-uppercase text-truncate"
                                                     >
                                                         {item.questionCategories}
                                                     </button>
                                                 )}
                                                 {item.topics && (
                                                     <button
                                                         style={{ maxWidth: 65, marginRight: 2 }}
                                                         className="blue-tag small-tag text-uppercase text-truncate"
                                                     >
                                                         {item.topics}
                                                     </button>
                                                 )}
                                                 <button className="tag-epost small-tag text-uppercase text-truncate">
                                                     {T.t('r_question_type_' + QuestionType[item.questionType].toString())}
                                                 </button>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             );
                         })
                     ) : (
                         <>
                             <img style={{ marginInlineStart: 'calc(50% - 89px)', marginTop: '2em' }} src={imgAnn} />
 
                             <h5 id="searched" className="d-none" style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                 {T.t('r_gen_exam_session_question_not_found_criter')}
                             </h5>
                             <h5 id="unsearched" className="d-block" style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                 {T.t('r_gen_exam_session_question_not_searched')}
                             </h5>
                         </>
                     )
                   }

                    {this.props.addQuestionDatas && this.props.addQuestionDatas.results && this.props.addQuestionDatas.results.length > 0 && (
                        <div className="row-options justify-content-end">
                            <div className="page-sorting d-flex align-items-center justify-content-center" style={{ marginTop: '5px' }} />
                            <Paginate
                                class={'custom-paginate'}
                                filters={this.props.addQuestionDatas.filters}
                                onPageChange={this.onPageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddQuestionModalProps): IAddQuestionModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAddQuestionModalProps = Object.assign({}, ownProps, {
        addQuestionDatas: state.examSession.addQuestionDatas,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        isDefaultUpdateQuestion: state.examSession.isDefaultUpdateQuestion,
        publishDatas: state.examSession.publishDatas
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.examSession.addQuestionDatas === prev.examSession.addQuestionDatas &&
        next.examSession.isDefaultUpdateQuestion === prev.examSession.isDefaultUpdateQuestion &&
        next.examSession.publishDatas === prev.examSession.publishDatas
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddQuestionModal = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddQuestionModal);

export default CAddQuestionModal;
